import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import config from 'devextreme/core/config';

if (environment.production) {
  enableProdMode();
  window.console.log = () => {
    //not to be empty
  };
  window.console.warn = () => {
    //not to be empty
  };
}

config({
  licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImUxMjJlY2E3LWIwODUtNDllNi05MzhjLWRmMDNjYzM0MWUyNSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.bEyy0ldl2lzDr6mhz7HHsBqXnrsB252dsuunFbjIN/HO2iJBTCeF9eCY1xUGoROH35i7tu1ltAkFp04ces5vbTtWRl6r/K7LDyCzT25kDUtM0wO+Ptob+1OsCaYRtAyBhy7+3g=='
});
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

// ========================================
// FIX: PrimeNG Dropdown Scroll Reset
// ========================================
// Problem: When a dropdown value is cleared and reopened, 
// the scroll position remains at the previously selected item
// Solution: Reset scroll position to top whenever dropdown opens
// ========================================

// Wait for Angular to bootstrap, then add global dropdown listener
setTimeout(() => {
  // Use MutationObserver to detect when dropdown panels are added to DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          // Check if added node is a dropdown panel
          if (node.classList && node.classList.contains('p-dropdown-panel')) {
            // Reset scroll position to top
            const itemsWrapper = node.querySelector('.p-dropdown-items-wrapper');
            if (itemsWrapper) {
              itemsWrapper.scrollTop = 0;
            }
          }
          
          // Also check child elements
          const dropdownPanels = node.querySelectorAll && node.querySelectorAll('.p-dropdown-panel');
          if (dropdownPanels) {
            dropdownPanels.forEach((panel) => {
              const itemsWrapper = panel.querySelector('.p-dropdown-items-wrapper');
              if (itemsWrapper) {
                itemsWrapper.scrollTop = 0;
              }
            });
          }
        }
      });
    });
  });

  // Start observing the document body for dropdown panel additions
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}, 1000);
